import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { api } from "@/lib/api";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export default function JournalDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/journal/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-40 pb-28 text-center">
        <p className="text-brand-textSec">Post not found.</p>
        <Link to="/journal" className="text-brand-cyan mt-4 inline-block">Back to Journal</Link>
      </div>
    );
  }

  if (!post) {
    return <div className="pt-40 pb-28 text-center text-brand-textMuted">Loading…</div>;
  }

  return (
    <article className="pb-28" data-testid="journal-detail">
      <div className="relative pt-52 lg:pt-60">
        {post.cover_image && (
          <div className="absolute inset-0 opacity-30">
            <img src={post.cover_image} alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-base to-brand-base/40" />
          </div>
        )}
        <div className="relative z-10 max-w-3xl mx-auto px-5 lg:px-8">
          <Link to="/journal" className="inline-flex items-center gap-2 text-brand-textSec hover:text-brand-cyan text-sm mb-6" data-testid="journal-back-link">
            <ArrowLeft size={16} /> Back to Journal
          </Link>
          <div className="flex items-center gap-3 text-xs">
            <span className="text-brand-cyan uppercase tracking-wider">{post.category}</span>
            <span className="text-brand-textMuted">{fmtDate(post.created_at)}</span>
            {post.is_sample && (
              <span className="text-[10px] uppercase tracking-wider bg-white/5 text-brand-textSec px-2.5 py-1 rounded-full">Sample content</span>
            )}
          </div>
          <h1 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight text-glow">
            {post.title}
          </h1>
        </div>
      </div>

      {post.cover_image && (
        <div className="max-w-4xl mx-auto px-5 lg:px-8 mt-10">
          <img src={post.cover_image} alt={post.title} className="w-full rounded-2xl border border-white/5" />
        </div>
      )}

      <Reveal className="max-w-3xl mx-auto px-5 lg:px-8 mt-12">
        <div className="prose-invert max-w-none">
          {post.body.split("\n\n").map((para, i) => (
            <p key={i} className="text-brand-textSec leading-relaxed text-[17px] mb-6">{para}</p>
          ))}
        </div>
      </Reveal>
    </article>
  );
}
